export default "__VITE_ASSET__CgozDWp3__"